import { connected } from 'process'

/**
 * Compares two versions. If (version1 < version2) returns 1,
 * (version1 > version2) returns -1, (version1 = version2) return 0.
 * @param {string} version1
 * @param {string} version2
 * @returns {number} <1, -1, 0>
 */
const compareVersion = (version1, version2) => {
    version1 = version1.split('.').map((num) => parseInt(num))
    version2 = version2.split('.').map((num) => parseInt(num))

    if (version1.length < 3 || version2.length < 3) return

    console.log(version1, version2)

    try {
        for (let index = 0; index < 3; index++) {
            if (version1[index] < version2[index]) return 1
            else if (version1[index] > version2[index]) return -1
        }
        // if (version1[2] < version2[2]) return 1
        return 0
    } catch (e) {
        console.log('ERROR', e)
        return 0
    }
}

const getVersionArguments = {
    Ace0: {
        deviceName: 'Playcomputer',
        version: '0.1',
    },
    Ace1: {
        deviceName: 'Playcomputer',
        version: '1.0',
    },
    Roboki: {
        deviceName: 'Roboki',
        version: '1.0',
    },
    Humanoid: {
        deviceName: 'Zing',
        version: '2.0',
    },
    Hexapod: {
        deviceName: 'Crawlee',
        version: '2.0',
    },
    Klaw: {
        deviceName: 'Klaw',
        version: '1.0',
    },
    Atr: {
        deviceName: 'Atr',
        version: '1.0',
    },
    Toki: {
        deviceName: 'Toki',
        version: '1.1',
    },
    Poki: {
        deviceName: 'Poki',
        version: '1.0',
    },
    Moki: {
        deviceName: 'Moki',
        version: '1.0',
    },
}

const getVersionObjNameKey = (connectedDevice) => {
    if (connectedDevice === 'Ace') return 'Playcomputer'
    if (connectedDevice === 'Hexapod') return 'Crawlee'
    if (connectedDevice === 'Humanoid') return 'Zing'
    if (connectedDevice === 'Atr') return 'Atr_h2'

    return connectedDevice
}

export { compareVersion, getVersionArguments, getVersionObjNameKey }
